module.exports = __webpack_public_path__ + "img/1F1F9-1F1E6.dee91c6d.svg";